// Разрешённый набор реакций — другие эмодзи бэкенд отклоняет.
export const REACTION_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🙏', '🎉'];

// Голосовые: не длиннее 3 минут, запись останавливается сама.
export const MAX_VOICE_DURATION_MS = 3 * 60 * 1000;

// Количество столбиков в waveform: произвольное число замеров схлопывается до него.
export const WAVEFORM_PEAKS = 50;

// Typing: публикуем не чаще раза в 2 сек, индикатор гасим через 3 сек.
export const TYPING_THROTTLE_MS = 2000;
export const TYPING_TIMEOUT_MS = 3000;

// Сколько живёт признак «пользователь онлайн» после последнего события от него.
export const ONLINE_WINDOW_MS = 60 * 1000;

// Сколько раз подряд пробуем поднять сокет, прежде чем остановиться.
// Без ограничения при 401 на /ws/info клиент долбится каждые 5 секунд бесконечно.
export const MAX_SOCKET_ATTEMPTS = 5;

// Группы: минимум 3 участника всего (создатель считается автоматически),
// максимум 100, название до 120 символов — ограничения бэкенда.
export const GROUP_MIN_MEMBERS = 3;
export const GROUP_MAX_MEMBERS = 100;
export const GROUP_TITLE_MAX_LENGTH = 120;

// Размер страницы истории.
export const HISTORY_PAGE_SIZE = 30;

// Окно, в котором оптимистичное сообщение сопоставляется с серверным
// (сервер не возвращает клиентский id, матчим по отправителю + тексту + времени).
export const OPTIMISTIC_MATCH_WINDOW_MS = 15 * 1000;
